import { requestAnalysis } from './analysisRequest';
import { prepareImageForAPI } from "./imageUtils";


/**
 * Analyze an image to determine if it needs AI retrace before SVG conversion.
 * Images with gradients, photos, or complex shading need to be flattened first.
 * 
 * @param {string} base64Image - The base64 encoded image (with or without data URL prefix)
 * @param {string} pendingFileId - Optional pending file ID for rate limiting
 * @returns {Promise<{needsRetrace: boolean, reason: string, imageType: string, hasGradients: boolean, message: string}>}
 */
export const analyzeImageForRetrace = async (base64Image, pendingFileId = null) => {
  try {
    console.log("🔍 Analyzing image for retrace suitability...");
    
    const base64String = await prepareImageForAPI(base64Image);
    
    const response = await requestAnalysis(
      'analyzeImageForRetrace',
      { 
        base64Image: base64String,
        pendingFileId,
      },
      30000
    );
    
    console.log("🔍 Analysis result:", response.data);
    
    return {
      needsRetrace: response.data.needsRetrace || false,
      reason: response.data.reason || "Unknown",
      imageType: response.data.imageType || "unknown",
      hasGradients: response.data.hasGradients || false,
      message: response.data.message || "",
    };
    
  } catch (error) {
    console.error("❌ Image analysis failed:", error);
    
    // On error, default to NOT requiring retrace
    // This prevents blocking the user if analysis fails
    return {
      needsRetrace: false,
      reason: "Analysis failed - proceeding with direct conversion",
      imageType: "unknown",
      hasGradients: false,
      message: "Proceeding with conversion...",
    };
  }
};

export default analyzeImageForRetrace;
